import { h } from 'preact';
import style from './style.css';
import cx from 'classnames';

const Footer = () => (
    <div className={cx(style.footer, 'flex', 'flex-col', 'items-center', 'justify-center')}>
        <div className={cx('flex', 'justify-center')}>
            <ul className={cx('flex', 'justify-between')}>
                <li><a href="/terms">TERMS OF USE</a></li>
                <li><a href="/privacy">PRIVACY POLICY</a></li>
                <li><a href="/faq">FAQ</a></li>
                <li><a href="/rules">RULES</a></li>
            </ul>
        </div>
        <div className={cx(style.copyright, 'flex', 'justify-center')}>
            {'\u00A9'} 2018 Player Index. All rights reserved.
        </div>
    </div>
);

export default Footer;


// WEBPACK FOOTER //
// ./components/Footer/index.jsx